<template>
    <component :is="parentWrapper" class="py-0 px-2">
        <v-card flat>
            <v-card-text>
                <div v-if="isPaid" class="subheading">
                    {{ successMessage }}
                </div>
                <div v-else class="subheading">
                    {{ pendingMessage }}
                </div>
            </v-card-text>
            <v-card-actions>
                <v-spacer></v-spacer>
                <v-btn to="/" color="primary">
                    {{ 'Back to the homepage' | translation }}
                </v-btn>
            </v-card-actions>
        </v-card>
        <page-content />
    </component>
</template>

<script>
    import StepBase from '@breakmedia/prime-vue-stepper/src/StepBase';

    export default {
        extends: StepBase,
        props: {
            route: {
                default: 'success',
            },
            paid: {
                type: Boolean,
                default: true,
            },
            order: {
                type: Object,
            },
        },
        computed: {
            isPaid() {
                const paid = this.$route.query.paid !== undefined ? this.$route.query.paid : this.paid;
                return paid === 'false' ? false : paid;
            },
            successMessage() {
                const message = this.$language.translate('Thank you for your order! ORDER_ID');
                return message.replace('ORDER_ID', this.orderId);
            },
            pendingMessage() {
                const message = this.$language.translate('The payment is sent. Once it\'s received the order will be completed. ORDER_ID');
                return message.replace('ORDER_ID', this.orderId);
            },
            orderId() {
                return this.order ? this.order.id : null;
            },
        },
    };
</script>
